import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers';
import * as settings from 'Settings';

// for redux dev tools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: !settings.IS_PROD,
      traceLimit: 25,
    })
  : compose;

const configureStore = () => {
  const middlewares = [thunk];
  if (!settings.IS_PROD) {
    // middlewares.push(createLogger());
  }

  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  return store;
};

export default configureStore;
